// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend

/* eslint-disable @typescript-eslint/no-explicit-any, complexity, no-prototype-builtins,max-lines, @typescript-eslint/ban-ts-comment */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Optional,
  Output,
  Renderer2,
  Self,
  SimpleChanges
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControlName,
  NgControl
} from '@angular/forms';
import { FieldItem, HelpModal, UlItem } from '../../../models/ui.interfaces';

@Component({
  selector: 'idp-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent
  implements ControlValueAccessor, AfterViewInit, OnChanges
{
  @Input() addMargin = false;
  @Input() ariaLabel = '';
  @Input() arrowPosition = 'right';
  @Input() bottomLabelIcon = false;
  @Input() bottomLabelText = '';
  @Input() calcEstimateBtnClicked: any;
  @Input() error = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() helpModal: HelpModal = {} as HelpModal;
  @Input() id = '';
  @Input() initialValueIndex = 0;
  @Input() items: UlItem[] = [];
  @Input() labelTxt = '';
  @Input() placeholderText = '';
  @Input() submitAttempt = false;
  @Input() topLabelIcon = false;
  @Input() topLabelText = '';
  @Input() noDisableField = false;
  @Input() setSelectedValue: UlItem = {} as UlItem;
  @Input() flow = '';
  @Output() value: EventEmitter<FieldItem> = new EventEmitter<FieldItem>();
  @Output() topLabelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() bottomLabelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() tooltipClicked: EventEmitter<string> = new EventEmitter();
  disabled = false;
  disableFocus = false;
  open = false;
  focused = false;
  selectedItem: UlItem | null = {} as UlItem;
  selectedItemIndex = 0;
  firstKeyDown = true;
  liFocused = false;
  dropdownWrapperFocused = false;
  allowFocusChange = true;
  hasValue = false;
  errorMessage = '';
  recursiveLabel = '';
  fixByBottom = 'unset';
  private onChange: ((item?: FieldItem | string) => void) | undefined;
  private onTouched: (() => void) | undefined;

  constructor(
    private elementRef: ElementRef,
    private ren: Renderer2,
    private cdr: ChangeDetectorRef,
    @Optional() @Self() private ngControl: NgControl,
    @Optional() private controlName: FormControlName
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get errorState() {
    if (
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched &&
      (this.calcEstimateBtnClicked || this.submitAttempt) &&
      Object.keys(this.errorMessages).length
    ) {
      this.errorMessage =
        this.errorMessages[Object.keys(this.ngControl.errors)[0]];
    }

    return (
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched &&
      (this.calcEstimateBtnClicked || this.submitAttempt)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('setSelectedValue')) {
      this.setSelectedItem(
        changes['setSelectedValue'].currentValue,
        true,
        true,
        true
      );
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    if (this.setSelectedValue) {
      this.writeValue(this.setSelectedValue);
      this.cdr.detectChanges();
    }
  }

  toggle(event: any, passthrough = false) {
    this.allowFocusChange = false;
    if (!passthrough) {
      event.preventDefault();
    }

    if (event.target.tagName === 'li') {
      this.open = false;
      return;
    } else {
      this.open = !this.open;
    }

    if (this.open) {
      const element = event.target;

      if (element.tagName === 'svg') {
        event.target.parentElement
          .querySelector('.idp-autocomplete__selected')
          .focus();
      } else if (element.tagName === 'DIV' || element.tagName === 'SPAN') {
        setTimeout(() => {
          this.elementRef.nativeElement
            .querySelector('.idp-autocomplete .idp-input')
            .focus();
        });
      } else {
        setTimeout(() => {
          event.target.parentElement.focus();
        });
      }
    }

    this.allowFocusChange = true;
  }

  close() {
    this.open = false;
  }

  refocus() {
    setTimeout(() => {
      const query = this.id
        ? `.idp-autocomplete#${this.id}-container .idp-input`
        : 'idp-autocomplete .idp-input';
      this.ren
        .parentNode(this.elementRef.nativeElement)
        .querySelector(query)
        .focus();
    });
  }

  disableOrEnable() {
    const input = this.elementRef.nativeElement.querySelector('idp-input');
    if (this.disabled) {
      input.setAttribute('disabled', true);
      input.setAttribute('disableFocus', true);
    } else {
      input.removeAttribute('disabled');
      input.removeAttribute('disableFocus');
    }
  }

  selected(event: any, activeLiItem?: any, stopPropagation = true) {
    if (stopPropagation) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!activeLiItem) {
      event.target.parentElement.parentElement.parentElement
        .querySelector('div:first-child')
        .focus();
      if (event.target.dataset.label && event.target.dataset.value) {
        this.setSelectedItem(
          {
            label: event.target.dataset.label,
            value: event.target.dataset.value
          },
          true
        );
      }
    } else {
      if (stopPropagation) {
        this.refocus();
      }
      this.setSelectedItem(
        {
          label: activeLiItem.dataset.label,
          value: activeLiItem.dataset.value
        },
        true
      );
    }

    this.firstKeyDown = false;
    this.open = false;
    this.hasValue = true;
  }

  findMatchingItemValue(value: string): UlItem[] {
    return this.items.filter((item) => {
      // @ts-ignore
      return item.value.toLowerCase() === value.toLowerCase();
    });
  }

  setValueOnTab($event: any) {
    if (this.ngControl) {
      // @ts-ignore
      this.ngControl.control.setErrors(null);
      // @ts-ignore
      this.ngControl.control.updateValueAndValidity();
    }
    this.selected($event, false, false);
  }

  setInputValueErrors($event: any) {
    this.setSelectedItem($event, true, false, false);
    if (
      $event.value &&
      !this.findMatchingItemValue($event.value).length &&
      this.ngControl
    ) {
      // @ts-ignore
      this.ngControl.control.setErrors({
        invalid: this.errorMessages['invalid']
      });
      if (this.onChange) {
        this.onChange({
          id: this.id,
          value: $event.value
        });
      }
    } else {
      if (this.ngControl) {
        // @ts-ignore
        this.ngControl.control.setErrors(null);
        // @ts-ignore
        this.ngControl.control.updateValueAndValidity();
      }
    }
  }

  inputValue($event: any) {
    const input = this.elementRef.nativeElement.querySelector('input');
    if (
      $event.codeKey !== 'Tab' &&
      $event.codeKey !== 'Shift' &&
      $event.codeKey !== 'Enter'
    ) {
      this.setInputValueErrors($event);
    }
    if (input && input.value === '') {
      this.selectedItem = null;
      this.open = false;
      this.items = [];
    }
  }

  setSelectedItem(
    item: UlItem,
    triggerChange = false,
    noUpdate = false,
    itemSelected = true
  ) {
    if (this.enforceDisabledState()) {
      return;
    }

    this.setRecursiveLabel(item);

    if (item && item.value === '') {
      this.resetControl();
    }

    if (item && item.value) {
      if (itemSelected) {
        this.selectedItem = item;
      } else {
        this.selectedItem = null;
      }
      this.selectedItemIndex = this.getCurrentSelectedItemIndex();
      this.fetchData(noUpdate, item);
      this.triggerChanges(item, triggerChange);
    }
    if (this.ngControl) {
      // @ts-ignore
      this.ngControl.control.setErrors(null);
      // @ts-ignore
      this.ngControl.control.updateValueAndValidity();
    }

    this.setOpenFlag(item);
  }

  resetControl() {
    if (this.onChange) {
      // @ts-ignore
      this.onChange(null);
    }

    this.selectedItem = null;
    this.selectedItemIndex = 0;
    this.open = false;
  }

  setOpenFlag(item: any) {
    this.open = !(
      !item ||
      !item.hasOwnProperty('value') ||
      item.codeKey === 27 ||
      item.codeKey === 13 ||
      item.codeKey === 'Enter'
    );
  }

  fetchData(noUpdate: any, item: any) {
    if (!noUpdate && item.codeKey !== 27 && item.codeKey !== 13) {
      this.value.emit({
        id: this.id,
        value: item.value
      });
    }
  }

  makeItemSelection(event: any, stopPropagation = true) {
    const parent = this.ren.parentNode(this.elementRef.nativeElement);
    const query = this.id
      ? `ul#${this.id}-desc .idp-autocomplete__list-item.active`
      : '.idp-autocomplete__list-item.active';
    const activeLiItem = parent.querySelector(query);
    if (this.open) {
      this.selected(event, activeLiItem, stopPropagation);
    }
  }

  triggerChanges(item: UlItem, triggerChange: any) {
    let listItemValue: string | undefined;
    this.items.forEach((listItem) => {
      if (listItem.label === item.value || listItem.value === item.value) {
        triggerChange = true;
        listItemValue = listItem.value;
      }
    });

    this.setRecursiveLabel(item);

    if (this.onChange) {
      // @ts-ignore
      this.onChange(
        // @ts-ignore
        item.value === '' || !triggerChange
          ? null
          : {
              id: this.id,
              value: listItemValue ? listItemValue : item.value
            }
      );
    }
  }

  getCurrentSelectedItemIndex(): number {
    let selectedItemIndex = 0;
    if (this.selectedItem && this.items && this.items.length) {
      this.items.forEach((item, index) => {
        if (JSON.stringify(item) === JSON.stringify(this.selectedItem)) {
          selectedItemIndex = index;
        }
      });
    }
    return selectedItemIndex;
  }

  updateSelection(event: any, direction: any) {
    if (this.enforceDisabledState()) {
      return;
    }

    const selectedItemIndex = this.getCurrentSelectedItemIndex();
    event.preventDefault();
    event.stopPropagation();

    this.allowFocusChange = false;

    if (!this.open) {
      this.open = true;
    }

    if (direction === 'up') {
      this.selectPrevious(selectedItemIndex);
    }

    if (direction === 'down') {
      this.selectNext(selectedItemIndex);
    }

    this.hasValue = true;
    this.allowFocusChange = true;
    this.firstKeyDown = false;
  }

  selectPrevious(selectedItemIndex: number) {
    let listItem;
    let query = '';
    if (
      (this.firstKeyDown && this.placeholderText) ||
      selectedItemIndex === 0
    ) {
      this.setSelectedItem(this.items[this.items.length - 1], false, true);
      query = '.idp-autocomplete ul#' + this.id + '-desc li:last-child';
      listItem = this.ren
        .parentNode(this.elementRef.nativeElement)
        .querySelector(query);
    } else {
      this.setSelectedItem(this.items[selectedItemIndex - 1], false, true);
      query =
        '.idp-autocomplete ul#' +
        this.id +
        '-desc li:nth-child(' +
        selectedItemIndex +
        ')';
      listItem = this.ren
        .parentNode(this.elementRef.nativeElement)
        .querySelector(query);
    }

    if (listItem) {
      listItem.focus();
    }
  }

  selectNext(selectedItemIndex: number) {
    let listItem;
    let query = '';
    if (
      (this.firstKeyDown && this.placeholderText) ||
      selectedItemIndex === this.items.length - 1
    ) {
      this.setSelectedItem(this.items[0], false, true);
      query = '.idp-autocomplete ul#' + this.id + '-desc  li:first-child';
      listItem = this.ren
        .parentNode(this.elementRef.nativeElement)
        .querySelector(query);
    } else {
      this.setSelectedItem(this.items[selectedItemIndex + 1], false, true);
      query = '.idp-autocomplete ul#' + this.id + '-desc  li.active + li';
      listItem = this.ren
        .parentNode(this.elementRef.nativeElement)
        .querySelector(query);
    }

    if (listItem) {
      listItem.focus();
    }
  }

  liChangeFocus(focused: boolean) {
    if (this.allowFocusChange) {
      this.liFocused = focused;
    }
    if (this.flow === 'flight-lookup') {
      this.elementRef.nativeElement.scrollIntoView({
        behavior: 'auto',
        block: 'center'
      });
    }
  }

  dropdownWrapperChangeFocused(focused: boolean) {
    if (this.allowFocusChange) {
      this.dropdownWrapperFocused = focused;
    }
  }

  setFocused($event: any) {
    this.focused = $event;
  }

  checkFocused() {
    if (!this.liFocused && !this.dropdownWrapperFocused) {
      this.focused = false;
      this.close();
      if (this.onTouched) {
        this.onTouched();
      }
    } else {
      this.focused = true;
    }
  }

  notify(level: any) {
    if (level === 'top') {
      this.topLabelClicked.emit(true);
    } else {
      this.bottomLabelClicked.emit(true);
    }
  }

  iconClicked() {
    this.tooltipClicked.emit(this.id);
  }

  writeValue(obj: UlItem) {
    this.setRecursiveLabel(obj);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: any) {
    this.disabled = isDisabled && !this.noDisableField;
  }

  setRecursiveLabel(obj: UlItem): void {
    if (obj === null) {
      this.recursiveLabel = '';
    } else {
      this.recursiveLabel =
        (obj && obj.hasOwnProperty('value')
          ? obj.value
          : this.recursiveLabel) || '';
    }
  }

  allowKeydown($event: KeyboardEvent): boolean {
    const key: string = $event.key;
    return key === 'Tab' ? true : !this.enforceDisabledState();
  }

  enforceDisabledState(): boolean {
    if (this.disabled) {
      this.close();
      this.focused = false;
      return true;
    }
    return false;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target) && this.open) {
      // const input = this.elementRef.nativeElement.querySelector('input');
      // this.setSelectedItem(
      //   {
      //     id: this.id,
      //     value: input.value
      //   },
      //   true
      // );
      this.dropdownWrapperChangeFocused(false);
      this.checkFocused();
    }
  }

  manageFocus(focus = false) {
    if (this.enforceDisabledState()) {
      return;
    }

    this.dropdownWrapperChangeFocused(focus);
    this.checkFocused();
  }
}
